<template>
  <v-app id="inspire">
    <v-app-bar :color="appBarBg" elevation="0" height="64" class="app-bar-custom">
      <v-app-bar-nav-icon @click="drawer = !drawer" color="white" class="ml-1" />

      <div class="bar-brand ml-2">
        <v-img :src="logoAOM" contain height="36" width="36" class="bar-logo" />
        <span class="bar-title">AOM Admin</span>
      </div>

      <v-spacer />

      <!-- Engrenagem de tema -->
      <v-menu location="bottom end" :close-on-content-click="true">
        <template v-slot:activator="{ props }">
          <v-btn icon color="white" variant="text" class="mr-1" v-bind="props">
            <v-icon>mdi-cog-outline</v-icon>
          </v-btn>
        </template>

        <v-card rounded="lg" width="200" class="pa-1 theme-menu" elevation="8">
          <v-list density="compact" nav>
            <v-list-subheader class="text-caption font-weight-bold">Aparência</v-list-subheader>

            <v-list-item
              rounded="lg"
              :active="currentTheme === 'light'"
              active-color="primary"
              @click="setTheme('light')"
            >
              <template v-slot:prepend>
                <v-icon size="18">mdi-weather-sunny</v-icon>
              </template>
              <v-list-item-title class="text-body-2">Claro</v-list-item-title>
            </v-list-item>

            <v-list-item
              rounded="lg"
              :active="currentTheme === 'dark'"
              active-color="primary"
              @click="setTheme('dark')"
            >
              <template v-slot:prepend>
                <v-icon size="18">mdi-weather-night</v-icon>
              </template>
              <v-list-item-title class="text-body-2">Escuro</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>

      <v-btn icon color="white" variant="text" class="mr-1">
        <v-icon>mdi-bell-outline</v-icon>
      </v-btn>

      <v-btn
        prepend-icon="mdi-logout-variant"
        variant="tonal"
        color="white"
        size="small"
        class="text-none mr-3 logout-btn"
        rounded="lg"
        @click="handleLogout"
      >
        Sair
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" elevation="0" border="0" width="248" :color="drawerBg">
      <BarraLateral />
    </v-navigation-drawer>

    <v-main>
      <v-container fluid class="fill-height pa-0">
        <v-row no-gutters class="fill-height w-100">
          <v-col class="d-flex flex-column">
            <router-view />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import BarraLateral from "@/components/navegacao/BarraLateral.vue";
import logoAOM from "@/assets/LogoAOM.png";
import { getAuth, signOut, onAuthStateChanged } from "firebase/auth";

export default {
  name: "LayoutPadrao",
  components: { BarraLateral },
  data: () => ({
    drawer: true,
    logoAOM,
    currentTheme: localStorage.getItem("aom-theme") || "light",
  }),
  computed: {
    isDark() {
      return this.currentTheme === "dark";
    },
    appBarBg() {
      return this.isDark ? "#0f1c35" : "#2563eb";
    },
    drawerBg() {
      return this.isDark ? "#0f1c35" : "#dbeafe";
    },
  },
  created() {
    this.verificarAutenticacao();
  },
  methods: {
    setTheme(theme) {
      this.currentTheme = theme;
      this.$vuetify.theme.global.name = theme;
      localStorage.setItem("aom-theme", theme);
    },
    verificarAutenticacao() {
      const auth = getAuth();
      onAuthStateChanged(auth, async (user) => {
        if (!user) {
          this.limparSessaoERedirecionar();
        } else {
          const token = await user.getIdToken(true);
          localStorage.setItem("idToken", token);
        }
      });
    },
    async handleLogout() {
      try {
        const auth = getAuth();
        await signOut(auth);
        this.limparSessaoERedirecionar();
      } catch (error) {
        console.error("Erro ao deslogar:", error);
      }
    },
    limparSessaoERedirecionar() {
      localStorage.removeItem("idToken");
      localStorage.removeItem("lastRoute");
      localStorage.removeItem("userPermissions");
      localStorage.removeItem("accessUser");
      if (this.$store) this.$store.dispatch("logout");
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
.app-bar-custom {
  border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
}

.bar-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.bar-logo {
  border-radius: 8px;
  flex-shrink: 0;
}

.bar-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.01em;
  font-family: 'Poppins', Roboto, sans-serif;
}

.logout-btn {
  border: 1px solid rgba(255,255,255,0.18) !important;
}


.fill-height {
  min-height: calc(100vh - 64px);
}
</style>
